<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 80" x="0px" y="0px" :width="width" :fill="color">
    <g>
      <path d="M59,11V21a2.006,2.006,0,0,0,2-2V13A2.006,2.006,0,0,0,59,11Z"/>
      <circle cx="17" cy="30" r="3"/>
      <path d="M40,46.5a10.5,10.5,0,0,1-21,0V41H15v5.5a14.5,14.5,0,0,0,29,0V31H40Z"/>
      <path
          d="M31,35V7a4,4,0,0,0-4-4H7A4,4,0,0,0,3,7V35a4,4,0,0,0,4,4H27A4,4,0,0,0,31,35ZM6,20V6H28V20ZM17,36a6,6,0,1,1,6-6A6,6,0,0,1,17,36Z"/>
      <path
          d="M55,9H48.89a8.081,8.081,0,0,0-3.58.84l-4.1,2.05A4.02,4.02,0,0,0,39,15.47V29h6V21l2.31,1.16a8.081,8.081,0,0,0,3.58.84H55a2.006,2.006,0,0,0,2-2V11A2.006,2.006,0,0,0,55,9Zm-1.2,7.6-3,4a1.013,1.013,0,0,1-.8.4,1.029,1.029,0,0,1-.6-.2,1,1,0,0,1-.2-1.4L51,17H49a1,1,0,0,1-.8-1.6l3-4a1,1,0,1,1,1.6,1.2L51,15h2a1,1,0,0,1,.8,1.6Z"/>
      <path
          d="M22,9H10v8H22V15h2V11H22Zm-8,5a1,1,0,0,1-2,0V12a1,1,0,0,1,2,0Zm3,0a1,1,0,0,1-2,0V12a1,1,0,0,1,2,0Zm3,0a1,1,0,0,1-2,0V12a1,1,0,0,1,2,0Z"/>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: [String, Number],
      default: 24,
    },
    color: {
      type: String,
      default: 'currentColor',
    },
  },
}
</script>
